<div class="cb-margin flex-col flex">
    @if (canCreateRFI()) {
        <div class="cb-margin-bottom end-center flex-row">
            @if (councilRfis?.length < 1) {
                <span class="start-center flex-row flex">
                    <mat-icon class="mat-accent">info</mat-icon>
                    <span class="mat-body-2">&nbsp;There are no RFIs for this Consent</span>
                </span>
            }
            <button
                mat-raised-button
                color="primary"
                (click)="addCouncilRfi()"
                [disabled]="!mappedItem?.canAddCouncilRfisToConsent"
            >
                Add Council RFI
            </button>
        </div>
    }
    @for (rfi of councilRfis; track rfi) {
        <cb-council-rfi-list-card
            class="cb-margin-bottom"
            [councilRfiDto]="rfi"
            (viewCouncilRfi)="view($event)"
            [redirect]="true"
        ></cb-council-rfi-list-card>
    }
</div>
